import { useState } from "react"
import { FiShare } from "react-icons/fi"
import { IoMdClose } from "react-icons/io"

const PWAInfoPopup = () => {
	const [visible, setVisible] = useState(true)

	if (!visible) return null

	return (
		<div className="fixed right-[1%] top-2.5 z-[9999] max-w-[90%] rounded-lg border border-[#5EAFFF] bg-white p-4 text-center text-sm text-black/80 shadow-md">
			<button
				onClick={() => setVisible(false)}
				className="absolute right-2 top-1.5 text-xl text-black/60 hover:text-black focus:outline-none"
			>
				<IoMdClose />
			</button>
			<div className="pr-2 pt-3">
				<div className="flex flex-wrap items-center gap-1 text-sm text-gray-800">
					<span>Install the web app on your device. Tap</span>
					<FiShare className="text-red-500" size={18} />
					<span>icon and then tap &quot;Add to Home Screen&quot;</span>
				</div>
			</div>
		</div>
	)
}

export default PWAInfoPopup
